export * from '@fhs/routing/src/routes/v2/_layout';
export { default } from '@fhs/routing/src/routes/v2/_layout';
